import React, { useState } from "react";
import {
  Grid,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Box,
  Grow,
  Link,
  Icon
} from "@material-ui/core";

import { useSelector } from "react-redux";

import styles from "./alert.scss";
import InfoIcon from "../icons/info-circle-solid.svg";
import WarningIcon from "../icons/exclamation-triangle-solid.svg";
import ErrorIcon from "../icons/times-circle-solid.svg";
import SuccessIcon from "../icons/check-circle-solid.svg";
import DefaultIcon from "../icons/exclamation-circle-solid.svg";
import QuestionIcon from "../icons/question-circle-solid.svg";

const Alert = () => {
  const [openMoreDetails, setOpenMoreDetails] = useState(false);

  const { type, open, title, message, stacktrace, buttons } = useSelector(
    (state) => state.ReactPrettyAlert
  );

  const IconMessage = () => {
    const iconsMapped = {
      info: (
        <div className={styles.icon}>
          <img src={InfoIcon} className={styles["icon-info"]} />
        </div>
      ),
      warning: (
        <div className={styles.icon}>
          <img src={WarningIcon} className={styles["icon-warning"]} />
        </div>
      ),
      error: (
        <div className={styles.icon}>
          <img src={ErrorIcon} className={styles["icon-error"]} />
        </div>
      ),
      success: (
        <div className={styles.icon}>
          <img src={SuccessIcon} className={styles["icon-success"]} />
        </div>
      ),
      question: (
        <div className={styles.icon}>
          <img src={QuestionIcon} className={styles["icon-question"]} />
        </div>
      ),
      default: (
        <div className={styles.icon}>
          <img src={DefaultIcon} className={styles["icon-default"]} />
        </div>
      )
    };

    return iconsMapped[type] || iconsMapped.default;
  };

  const Content = () => {
    if (Array.isArray(message)) {
      return (
        <>
          {message.map((messageItem, index) => (
            <p
              className={styles["dialog-message-content"]}
              key={`dialog-message-content-${index}`}
            >
              {messageItem}
            </p>
          ))}
        </>
      );
    }

    return <p className={styles["dialog-message-content"]}>{message}</p>;
  };

  const MoreDetails = () => {
    return (
      <div className={styles["dialog-message-more-details-content"]}>
        {stacktrace && (
          <>
            <p>
              <strong>Status:</strong> {stacktrace.status}
            </p>
            <p className={styles["more-details-link"]}>
              <strong>Para mais informações acesse:</strong>
              <a
                href={stacktrace.link}
                rel="noopener noreferrer"
                target="_blank"
              >
                {stacktrace.link}
              </a>
            </p>
            <p>
              <strong>Detalhes técnicos:</strong> {stacktrace.throwable}
            </p>
          </>
        )}
      </div>
    );
  };

  return (
    <Dialog
      className={styles["custom-dialog-message-container"]}
      open={!!open}
      TransitionComponent={Grow}
      maxWidth={buttons && buttons.length > 1 ? "xs" : "xs"}
      transitionDuration={300}
      fullWidth
    >
      <DialogContent>
        <IconMessage />
        <h3 className={styles["dialog-message-title"]}>{title}</h3>
        <Content />

        {stacktrace && (
          <Link
            className={styles["dialog-message-more-details"]}
            onClick={() => setOpenMoreDetails(!openMoreDetails)}
          >
            {!openMoreDetails && (
              <div className={styles["dialog-message-span-container"]}>
                <Icon className={styles["dialog-message-icon-actions"]}>
                  add
                </Icon>
                <span className={styles["dialog-message-span-actions"]}>
                  Mais detalhes
                </span>
              </div>
            )}

            {openMoreDetails && (
              <div className={styles["dialog-message-span-container"]}>
                <Icon className={styles["dialog-message-icon-actions"]}>
                  remove
                </Icon>
                <span className={styles["dialog-message-span-actions"]}>
                  Menos detalhes
                </span>
              </div>
            )}
          </Link>
        )}

        {openMoreDetails && <MoreDetails />}
      </DialogContent>

      <DialogActions>
        <Grid
          container
          direction="row"
          justify={buttons && buttons.length > 1 ? "flex-end" : "center"}
          alignItems="center"
        >
          {buttons &&
            [...buttons].reverse().map((button, index) => (
              <Box paddingLeft={1} key={`${button.title}-{index}`}>
                <Button
                  variant={
                    button.main || buttons.length === 0 ? "contained" : "text"
                  }
                  color={
                    button.main || buttons.length === 0
                      ? "primary"
                      : "secondary"
                  }
                  className={styles["dialog-message-close-button"]}
                  onClick={button.onClick}
                >
                  {button.title}
                </Button>
              </Box>
            ))}
        </Grid>
      </DialogActions>
    </Dialog>
  );
};

export default Alert;
